<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-codepen fa-fw"></i>Setores
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="pull-right">
          <a
            class="btn btn-default"
            @click="
              addButton.seeForm = !addButton.seeForm;
              sector = {};
            "
          >
            <span v-if="addButton.seeForm">
              <i class="fa fa-search fa-fw"></i>Buscar
            </span>
            <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
          </a>
          <br />
          <br />
          <br />
        </div>

        <div class="col-lg-12">
          <form
            v-if="addButton.seeForm"
            role="form"
            @submit.stop.prevent="send"
          >
            <input v-model="sector.id" type="hidden" />
            <div class="form-group">
              <label>Id</label>
              <input v-model="sector.id" class="form-control" disabled />
            </div>
            <div class="form-group">
              <label>Nome</label>
              <input v-model="sector.name" class="form-control" required />
            </div>
            <div class="form-group">
              <label>Cor</label>
              <input
                type="color"
                v-model="sector.color"
                class="form-control"
                list="presetColors"
                required
              />
              <datalist id="presetColors">
                <option>#ffcccc</option>
                <option>#ffd9cc</option>
                <option>#ffe6cc</option>
                <option>#fff2cc</option>
                <option>#ffffcc</option>
                <option>#f2ffcc</option>
                <option>#e6ffcc</option>
                <option>#d9ffcc</option>
                <option>#ccffcc</option>
                <option>#ccffd9</option>
                <option>#ccffe6</option>
                <option>#ccfff2</option>
                <option>#ccffff</option>
                <option>#ccf2ff</option>
                <option>#cce6ff</option>
                <option>#ccd9ff</option>
                <option>#ccccff</option>
                <option>#d9ccff</option>
                <option>#e6ccff</option>
                <option>#f2ccff</option>
                <option>#ffccff</option>
                <option>#ffccf2</option>
                <option>#ffcce6</option>
                <option>#ffccd9</option>
                <option>#ffcccc</option>
              </datalist>
            </div>
            <div class="form-group">
              <label>Email</label>
              <input v-model="sector.email" class="form-control" required />
            </div>
            <div class="form-group">
              <label>Telefone</label>
              <input v-model="sector.phone" class="form-control" required />
            </div>
            <button type="submit" class="btn btn-block btn-info">Salvar</button>
            <br/>
            <div v-if="msg" class="alert alert-danger">
               <i class="fa fa-exclamation"></i>
               O campo <strong>Cor</strong> não pode ser nulo 
            </div>
          </form>
          <form v-else>
            <div class="form-group">
              <input
                v-model="search"
                class="form-control"
                placeholder="Buscar..."
              />
            </div>
          </form>
        </div>
      </div>
      <hr />
      <div class="row">
        <div v-if="filtred.length">
          <div class="col-lg-4" v-for="sector in filtred" :key="sector.id">
            <div class="panel panel-default">
              <div class="panel-heading" :style="sectorColor(sector.color)">
                <b
                  data-toggle="tooltip"
                  data-placement="top"
                  v-bind:title="sector.name">#{{ sector.id }} {{ sector.name.substring(0, 30) }}</b>
                <div class="pull-right">
                  <div class="btn-group" role="group">
                    <a
                      @click.stop="edit(sector.id)"
                      class="btn btn-sm btn-primary"
                      ><i class="fa fa-pencil fa-fw"></i
                    ></a>
                    <a
                      @click=" showModal = 1; show = sector.id"
                      class="btn btn-sm btn-danger"
                      ><i class="fa fa-trash fa-fw"></i
                    ></a>
                  </div>
                  <br />
                </div>
                <br />
              </div>
              <div class="panel-body" :style="sectorColor(sector.color)">
                <p>
                  <i class="fa fa-envelope fa-fw"></i>
                  {{ sector.email }}
                </p>
                <p>
                  <i class="fa fa-phone fa-fw"></i>
                  {{ sector.phone }}
                </p>
              </div>
            </div>
            <Modal v-if="showModal === 1 && show === sector.id">
              <i
                slot="close"
                @click="
                  showModal = null;
                  yes = null;
                "
                >&times;</i
              >
              <h2 slot="header"><i class="fa fa-times fa-fw"></i>Remover Setor</h2>
              <div slot="body">
                <h4>Deseja realmente remover o setor <strong>{{ sector.name }}?</strong></h4>
              </div>
              <div slot="footer">
                <button
                  type="button" class="btn btn-primary"
                  @click="
                    yes = true;
                    showModal = null;
                  "
                  @click.stop="remove(sector.id)"
                >
                  Confirmar
                </button>
                <button
                  class="btn btn-default"
                  @click="
                    yes = null;
                    showModal = null;
                  "
                >
                  fechar
                </button>
              </div>
            </Modal>
          </div>
        </div>
        <Modal v-if="showModal === 2">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Setor
          </h2>
          <div slot="body">
            <div
              class="alert alert-success alert-small"
            ><i class="fa fa-exclamation"></i>
              Setor cadastrado com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <Modal v-if="showModal === 3">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-times fa-fw"></i>Exclusão de Setor
          </h2>
          <div slot="body">
            <div
              class="alert alert-success alert-small"
            ><i class="fa fa-exclamation"></i>
              Setor excluído com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <div v-else-if="!filtred.length">
          <div class="alert alert-info">
            <p>
              <i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi
              encontrado
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>

import Modal from "../../components/ui-elements/Modal.vue";

export default {
  name: "Sectors",
  inject: ["loading"],
  components: { Modal },
  data() {
    return {
      search: "",
      addButton: { seeForm: false },
      sector: {},
      sectors: [],
      show: null,
      yes: null,
      showModal: null,
      msg: null,
    };
  },
  mounted() {
    this.loading.value = true;
    this.$http.get("sector").then((response) => {
      this.sectors = response.data.content;
    }).finally(() => {
        this.$nextTick(() => {
          $('[data-toggle="tooltip"]').tooltip();
        });
        setTimeout(() => (this.loading.value = false), 1000);
      });
  },
  methods: {
    sectorColor(color) {
      if (color) {
        return { backgroundColor: color };
      }
      return "";
    },
    send() {
      this.loading.value = true;
      if (this.sector.id) {
        this.$http
          .put(`/sector/${this.sector.id}`, this.sector)
          .then((response) => {
            this.sectors = this.sectors.filter(
              (item) => item.id != this.sector.id
            );
            this.sectors.push(response.data);
            this.sector = {};
            this.addButton.seeForm = false;
            this.showModal = 2;
            this.msg = null;
          })
          .catch((error) => {
            this.msg = error;
          });
        setTimeout(() => (this.loading.value = false), 1000);
      } else {
        this.$http
          .post("/sector", this.sector)
          .then((response) => {
            this.sector = {};
            this.sectors.push(response.data);
            this.addButton.seeForm = false;
            this.showModal = 2;
            this.msg = null;
          })
          .catch((error) => {
            this.msg = error;
          });
        setTimeout(() => (this.loading.value = false), 1000);
      }
    },
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`/sector/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.sector = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    remove(id) {
      const confirm = this.yes;

      if (confirm) {
        this.loading.value = true;
        this.$http
          .delete(`/sector/${id}`)
          .then((response) => {
            this.sectors = this.sectors.filter((item) => item.id != id);
            this.showModal = 3;
          })
          .catch((error) => alert(error));
        setTimeout(() => (this.loading.value = false), 1000);
      }
    },
  },
  computed: {
    filtred() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.sectors;
      }

      result = this.sectors.filter(
        (sector) => sector.name.toLowerCase().indexOf(search) > -1
      );

      return result.sort((a, b) => b.id - a.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Sectors.vue